import { render } from "./CreditoModal.vue?vue&type=template&id=fce6e8f2"
import script from "./CreditoModal.vue?vue&type=script&lang=js"
export * from "./CreditoModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__